<h3 class="font-color-navy bold-text background-lightGrey px-1">
  <i class="px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Comment(s)</span>
</h3>
<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<form (ngSubmit)="onSubmit()" #feedbackForm="ngForm" ngForm="feedbackForm" *ngIf="canComment">
  <div class="form-group">
    <div class="d-flex" style="display: block !important;">
      <editor class="form-control-lg" name="comment" [init]="init" [id]="taskId" ngModel #comment="ngModel"></editor>
      <div class="justify-content-right" *ngIf="!feedbackSubmitted" style="padding: 0rem 1rem;">
        <button [ngClass]="(comment.value != '' && comment.value != null)? 'btn-new-ui':'btn-new-ui-disabled'"
                type="submit"
                [disabled]="comment.value === '' || comment.value === null">
          Submit
        </button>
      </div>
    </div>

  </div>
</form>
<hr />
<span *ngIf="isListloading" class="justify-content-end text-end">
  <app-loading [displayeMessage]="true"></app-loading>
</span>
<div style="width:90%">
  <app-list [currentResponseId]="taskId"></app-list>
</div>
